// extracted by mini-css-extract-plugin
module.exports = {"button":"_2QQ6S","wrapper":"_17rmA","label":"_18vrG","bubble":"_2P0XW"};